import { Select, Spin } from "antd";
import { Option } from "antd/es/mentions";
import axios from "axios";
import React, { useEffect, useState } from "react";
import PaymentList from "./PaymentList";
import { BlinkBlur, OrbitProgress } from "react-loading-indicators";
import VoucherModal from "./VoucherModal";

const PaymentScreen = ({ isVisible,
  onClose,
  precoTotal,
  setPagamentoConcluido,
  setPagItem,
  pagamentos,
  setPagamentos,
  idLoja,
  formasDePagamento,
  totalPago,
  setTotalPago
}) => {

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem("operador");
  const [restauranteId, setRestauranteId] = useState('');

  const [loading, seetLoading] = useState(false);
  const [visualizarModalVoucher, setVisualizarModalVoucher] = useState(false);
  const [pagamentosTela, setPagamentosTela] = useState(pagamentos);
  const [totalPagoTela, setTotalPagoTela] = useState(totalPago);

  const [voucher, setVoucher] = useState('');
  const [informacoesVoucher, setInformacoesVoucher] = useState('');
  const [valor, setValor] = useState('');


  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken,
        },
      };

      axios
        .get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
          options,
        )
        .then(restaurante => {
          setRestauranteId(restaurante.data.id);
        });
      setPagamentosTela(pagamentos);
    }
  }, [idUser, accessToken]);


  const [formaDePagamentoSelecionada, setFormaDePagamentoSelecionada] =
    useState('01');

  useEffect(() => {
    console.log('precoTotal');
    console.log('precoTotal');
    console.log('precoTotal');
    console.log('precoTotal');
    console.log(precoTotal);
    console.log((parseFloat(precoTotal) - parseFloat(totalPagoTela)).toFixed(2));
    console.log(totalPagoTela);
    console.log(valor);

    // Formatar o valor com a máscara (por exemplo, R$ 1.000,00)
    let valorFormatado = parseFloat(parseFloat(precoTotal) - parseFloat(totalPagoTela)); // Converter para valor decimal
    valorFormatado = valorFormatado.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    setValor(valorFormatado);
    console.log(formaDePagamentoSelecionada);
  }, [precoTotal]);
  function formatISODate(isoString) {
    const date = new Date(isoString);

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Mês é zero-indexado
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const tratarValor = text => {
    console.log('valor');
    console.log(text);
    let valorFormatado = text.replace(/\D/g, '');
    // Verificar se o valor é vazio ou contém apenas zeros
    if (valorFormatado === '' || parseInt(valorFormatado) === 0) {
      setValor('R$ 0'); // Define o valor como vazio
      valorFormatado = 'R$ 0';
    } else {
      // Formatar o valor com a máscara (por exemplo, R$ 1.000,00)
      valorFormatado = parseFloat(valorFormatado) / 100; // Converter para valor decimal
      valorFormatado = valorFormatado.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }
    setValor(valorFormatado);
  };

  const [paymentType, setPaymentType] = useState("Cartão de Débito");
  const [amount, setAmount] = useState("");
  const [payments, setPayments] = useState([]);

  const handleAddPayment = () => {
    if (amount && parseFloat(amount) > 0) {
      setPayments((prevPayments) => [
        ...prevPayments,
        { type: paymentType, amount: parseFloat(amount) },
      ]);
      setAmount(""); // Limpa o campo de valor
    }
  };

  const adicionarPagamento = () => {
    console.log(formaDePagamentoSelecionada);
    if (formaDePagamentoSelecionada === '05') {
      console.log('Abrir modal');
      setVisualizarModalVoucher(true);
      return;
    }

    const totalPagoAux = parseFloat(totalPagoTela);
    const valorDigitadoAux = parseFloat(
      valor.replace('R$', '').replace('.', '').replace(',', '.').trim()
    );


    if (valorDigitadoAux == 0) {
      return;
    }
    console.log('adicionarPagamento');
    console.log('Forma de pagamento selecionada:', formaDePagamentoSelecionada);
    console.log('Valor digitado:', valor);
    console.log('Preço total:', precoTotal);
    console.log('Total pago auxiliar:', totalPagoAux);
    console.log('Valor digitado auxiliar:', valorDigitadoAux);

    if (totalPagoAux + valorDigitadoAux <= parseFloat(precoTotal) || formaDePagamentoSelecionada == '01') {
      console.log('formaDePagamentoSelecionada');

      console.log(formaDePagamentoSelecionada);
      if (valor && formaDePagamentoSelecionada) {
        const formaDePagamentoFiltrada = formasDePagamento.find(
          (formaPag) => formaPag.value === formaDePagamentoSelecionada
        );
        console.log(formasDePagamento);
        console.log('Forma de pagamento filtrada:', formaDePagamentoFiltrada);
        console.log('Forma de pagamento é válida:', formaDePagamentoFiltrada !== undefined);

        if (formaDePagamentoFiltrada !== undefined) {
          setTotalPagoTela(
            totalPagoAux + valorDigitadoAux
          );

          const novosPagamentos = [
            ...pagamentosTela,
            {
              tipo: formaDePagamentoSelecionada,
              tipoNome: formaDePagamentoFiltrada.label,
              valor: valor,
            },
          ];
          setPagamentosTela(novosPagamentos);

          console.log('Preço restante:', precoTotal - totalPagoAux - valorDigitadoAux);
          if (precoTotal - (totalPagoAux + valorDigitadoAux) >= 0) {
            setValor(
              (precoTotal - (totalPagoAux + valorDigitadoAux)).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })
            );
          } else {
            setValor(
              (0).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }));
          }


        }
      } else {
        console.log('Faltam o valor ou a forma de pagamento');
      }
    } else {
      console.log('Pagamento superior ao valor da compra');
    }
  };



  /* const confirmarPagamento = () => {
     setPagamentoConcluido(true);
     let pagItemAux = new Array();
     pagamentos.map(pagamento => {
       let valorFormatado = typeof pagamento.valor === 'string' ? parseFloat(pagamento.valor.replace(/\D/g, '')) / 100 : pagamento.valor;
 
       let pagamentoFormatado = {
         tPag: pagamento.tipo,
         vPag: valorFormatado.toFixed(2),
         xPag: pagamento.tipoNome,
       };
       console.log(pagamento.tipo);
       if (pagamento.tipo === "05" || pagamento.tipo === 5) {
         console.log('if de pagamento');
         pagamentoFormatado.idReferencialVoucher = informacoesVoucher.id;
       }
 
       pagItemAux.push(pagamentoFormatado);
     });
     setPagItem(pagItemAux);
 
     onClose();
   };*/

  const confirmarPagamento = () => {
    setPagamentoConcluido(true);
    setPagamentos(pagamentosTela);
    setTotalPago(totalPagoTela);
    setTotalPagoTela(0);
    const pagItemAux = pagamentosTela.map((pagamento) => {
      // Converte valor (string -> float)
      const valorFormatado =
        typeof pagamento.valor === "string"
          ? parseFloat(pagamento.valor.replace(/\D/g, "")) / 100
          : pagamento.valor;

      // Base do objeto
      let pagamentoFormatado = {
        tPag: pagamento.tipo,
        vPag: valorFormatado.toFixed(2),
        xPag: pagamento.tipoNome,
      };

      // Se for voucher (05)
      if (pagamento.tipo === "05" || pagamento.tipo === 5) {
        pagamentoFormatado.idReferencialVoucher = informacoesVoucher.id;
      }

      // Se for cartão (3 ou 4)
      if (pagamento.tipo === "03" || pagamento.tipo === 3 || pagamento.tipo === "04" || pagamento.tipo === 4) {
        pagamentoFormatado.card = {
          tpIntegracao: "2",
        };
      }

      return pagamentoFormatado;
    });

    setPagItem(pagItemAux);
    onClose();
  };














  /*const handleRemovePayment = (index) => {
    setPayments((prevPayments) =>
      prevPayments.filter((_, i) => i !== index)
    );
  };*/

  const total = 1.5;
  const paid = payments.reduce((sum, payment) => sum + payment.amount, 0);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>


      <div style={{ marginBottom: "10px" }}>
        {loading ? (
          <div className="loading">
            <Spin
              spinning={loading}
              tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
              size="large"
            />
          </div>
        ) : (
          <div>
            <h1 style={{ textAlign: 'center', marginBottom: '5px', marginTop: 0 }}>Formas de Pagamento</h1>
            <Select
              style={{
                width: '100%', // Usa toda a largura disponível do contêiner
                maxWidth: '300px', // Define um limite máximo de largura
                minWidth: '150px', // Define um limite mínimo de largura
              }}
              placeholder="Selecione a forma de pagamento"
              value={formaDePagamentoSelecionada}
              // onChange={(value) => setFormaDePagamentoSelecionada(value)}
              onChange={(value) => setFormaDePagamentoSelecionada(value)}
              dropdownMatchSelectWidth={false} // O dropdown pode ter largura própria
            >
              {formasDePagamento.map((forma) => (
                <Option key={forma.value} value={forma.value}>
                  {forma.label}
                </Option>
              ))}
            </Select>

            <input
              type="text"
              //placeholder="R$ 0,00"
              value={valor}
              onChange={(e) => tratarValor(e.target.value)}
              style={{ padding: "10px", marginRight: "10px" }}
            />
            <button onClick={adicionarPagamento} style={{ padding: "10px 20px", backgroundColor: 'black', color: 'white' }}>
              Adicionar Pagamento
            </button>

            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
              <div>
                <strong>Total:</strong>{' '}
                {Number(precoTotal || 0).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}

              </div>
              <div>
                <strong>Pago:</strong> {`${totalPagoTela.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}`}
              </div>
            </div>

            <PaymentList pagamentos={pagamentosTela} setPagamentos={setPagamentosTela} precoTotal={precoTotal} totalPago={totalPagoTela} setTotalPago={setTotalPagoTela} setValor={setValor} setPagamentoConcluido={setPagamentoConcluido}></PaymentList>
            <button
              onClick={() => {
                setPagamentosTela([]);
                setTotalPagoTela(0);
                onClose();
              }}
              style={{ ...styles.buttonRed }}
            >
              Fechar
            </button>
            <button
              disabled={parseFloat(precoTotal) > totalPagoTela ? true : false}
              style={{
                padding: "10px 20px",
                backgroundColor: parseFloat(precoTotal) > totalPagoTela ? "#ccc" : "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "5px",
                width: "110px",
                marginLeft: '10px',
                cursor: parseFloat(precoTotal) > totalPagoTela ? "not-allowed" : "pointer",
              }}
              onClick={confirmarPagamento}
            >
              Confirmar
            </button>


          </div>



        )}
      </div>

      <VoucherModal
        visible={visualizarModalVoucher}
        setVisible={setVisualizarModalVoucher}
        accessToken={accessToken}
        idLoja={idLoja}
        precoTotal={precoTotal}
        totalPago={totalPagoTela}
        setTotalPago={setTotalPagoTela}
        valor={valor}
        setValor={setValor}
        pagamentos={pagamentosTela}
        setPagamentos={setPagamentosTela}
        formaDePagamentoSelecionada={formaDePagamentoSelecionada}
        formasDePagamento={formasDePagamento}
        informacoesVoucher={informacoesVoucher}
        setInformacoesVoucher={setInformacoesVoucher}
      />

    </div>
  );
};


const styles = {
  buttonRed: {
    backgroundColor: "#ff5c5c",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "5px",
    cursor: "pointer",
    width: "110px"
  },

  buttonDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  }

}

export default PaymentScreen;
